import { render } from "./DashboardOrderList.vue?vue&type=template&id=308eb2a2"
import script from "./DashboardOrderList.vue?vue&type=script&lang=js"
export * from "./DashboardOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__